"use client";

import React from "react";

interface SubscriptionContextType {
  isActive: boolean;
}

const SubscriptionContext = React.createContext<
  SubscriptionContextType | undefined
>(undefined);

export function SubscriptionProvider(
  props: React.PropsWithChildren<SubscriptionContextType>,
) {
  return (
    <SubscriptionContext value={{ isActive: props.isActive }}>
      {props.children}
    </SubscriptionContext>
  );
}

export function useIsSubscriptionActive() {
  const context = React.use(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useIsSubscriptionActive must be used within a SubscriptionProvider",
    );
  }
  return context.isActive;
}
